import { render, staticRenderFns } from "./GaragesSelect.vue?vue&type=template&id=04542972"
import script from "./GaragesSelect.vue?vue&type=script&lang=js"
export * from "./GaragesSelect.vue?vue&type=script&lang=js"
import style0 from "./GaragesSelect.vue?vue&type=style&index=0&id=04542972&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports